module.exports = __webpack_public_path__ + "20250721160708/img/sq.0de8c021.png";